class pageTop {
  constructor(el, opt) {
    this.el = el;
    if(document.querySelector('.js-top-banner-swiper')){
      this.mobileBannerSwiper()
    }
  }
  mobileBannerSwiper() {
    const swiperWrap = document.querySelector('.js-top-banner-swiper');
    new Swiper(swiperWrap,{
      loop: true,
      slidesPerShow: 1,
      centeredSlides: true,
      spaceBetween: 2,
      pagination: {
        el: '.js-top-banner-swiper__pagination',
        type: 'bullets'
      }
    })
  }
}
